
<header id="header" >
  <form>
     <div class="top-header">
      <img class="logo" src="../../../assets/images/NEW_logo.png" alt="HRM" title="Home" />
      <div id="snackbar" class="show" [ngClass]="{hide: headerMsg.length < 1}">
        <span style="color: red;" *ngFor="let data of headerMsg">
          <span class="fitWidth">{{ data['message'] }}</span><br>
        </span>
      </div>
      <div class="loggedin-user">
        <div class="static-user">
          <span class="user-icon">
            <mat-icon>account_circle</mat-icon>
          </span>
          <div class="header-text"> 
            {{userDetails['detail']['name']}}
          </div>
          <div class="header-text"> 
            {{userRole}}
          </div>
          <span class="user-role-space">
          <ng-container *ngIf="userFlag">
            <form [formGroup]="dcRole">
              <mat-form-field class="col-sm-3 dc-drop" appearance="fill"> 
                  <mat-select formControlName="dcRole" disableOptionCentering="true"
                              [value]="defaultDC"
                              style="display: contents;"> 
                    <mat-option *ngFor="let dcs of dc" 
                          [value]="dcs.distributionCentreId"
                          (click)="selected(dcs.distributionCentreId, dcs.plantCode,dcs.distributionCentreName)"> 
                      {{dcs.plantCode}}, {{dcs.distributionCentreName}}
                    </mat-option> 
                  </mat-select> 
                </mat-form-field> 
              </form>
          </ng-container>
        </span>
        </div>
        <div class="logoutButton">
          <span matTooltip="Logout" class="material-icons logout-pointer" (click)="logout()">logout</span>
        </div>
      </div>
    </div>


  
  </form>
</header>
